import { ApiInsuranceWebhook, InsuranceWebhook } from '../../models/api-settings';

export function convertApiWebhookToViewData(apiData: ApiInsuranceWebhook): InsuranceWebhook {
    return {
        id: apiData._id,
        hookTypeId: apiData.hookType._id,
        url: apiData.url,
    };
}
